var map = {
	"./arrow_bottom--dark.svg": 76093,
	"./arrow_bottom.svg": 12938,
	"./camera_switcher.svg": 36736,
	"./events_list_switcher.svg": 44412,
	"./events_switcher.svg": 62788,
	"./marker_bike.svg": 88823,
	"./marker_parking.svg": 57158,
	"./marker_parking_normal_spot.svg": 38628,
	"./marker_parking_tip.svg": 74327,
	"./marker_parking_zone.svg": 32142,
	"./marker_parkometer.svg": 23158,
	"./parking_switcher.svg": 43268,
	"./poi_switcher.svg": 74568,
	"./traffic_switcher.svg": 81026,
	"./vms_board_switcher.svg": 82329,
	"./way_switcher.svg": 76898,
	"./weather_station_switcher.svg": 53530
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 98051;